// extracted by mini-css-extract-plugin
export var statItem = "_ii-1";
export var statsRow = "_ii-0";